module.exports = "<status-label activeText=\"{{getActiveText()}}\" inactiveText=\"{{getInactiveText()}}\" [active]=getActive()></status-label>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/things/statusLabel/statusLabel.component.html
// module id = ../../../../../src/app/components/things/statusLabel/statusLabel.component.html
// module chunks = main